"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumericalSearchEstimator = exports.Estimator = void 0;
const irt_1 = require("./irt");
var tf = require("@tensorflow/tfjs-core");
class Estimator {
    /**
     * Abstract class used to actualise theta parameter once a new item has been answered by the student
     * @param verbose : boolean which indicates if we want some details of what happened during the
     * optimization function used to get the new theta value
     */
    constructor(verbose = false) {
        this._calls = 0;
        this._evaluations = 0;
        this._verbose = verbose;
    }
    get _avgEvaluations() { return this._evaluations / this._calls; }
}
exports.Estimator = Estimator;
class NumericalSearchEstimator extends Estimator {
    /**
     * This class handles estimation of a new theta value after a new answer has been given by the student.
     * Theta is computed according to maximum likelihood principle.
     */
    constructor() {
        super();
    }
    estimate(discriminations, difficulties, administeredItems, responseVector, thetaEstimation, weights) {
        let newtonCG = (g, H, start, stepSize = 0.8, numIter = 15, tol = 1e-2) => {
            let xt = start;
            for (let i = 0; i < numIter; i++) {
                let xt_data = xt.dataSync();
                let xtplus1 = tf.sub(xt, tf.mul(stepSize, tf.dot((0, irt_1.inverseMatrix)(H(xt_data)), g(xt_data))));
                if (tf.abs(tf.max(tf.sub(xtplus1, xt))).dataSync[0] < tol) {
                    break;
                }
                xt = xtplus1;
            }
            return xt.dataSync();
        };
        var g = function (X) { return tf.sub(0, tf.tensor((0, irt_1.jacobian)(X, discriminations, difficulties, administeredItems, responseVector, weights, 0.25))); };
        var H = function (X) { return (0, irt_1.hessian)(X, discriminations, difficulties, administeredItems, 1); };
        var sol = newtonCG(g, H, thetaEstimation);
        return sol;
    }
}
exports.NumericalSearchEstimator = NumericalSearchEstimator;
